// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a3cc182","455":"dc22d7ed","488":"cf005360"}[chunkId] + ".chunk.js";
};